export function isCPF(document: string) {
    return document && document.length === 11 && /^\d{11}$/.test(document);
}
